export const cookies = {
    set: (name, val, sameSite, expires) => {
        sameSite = sameSite || 'Lax';
        let cookie = name + '=' + encodeURIComponent(val) + ';' + 'SameSite=' + sameSite + ';path=/;';
        if (window.location.protocol == 'https:') {
            cookie += 'Secure;';
        }
        if (expires) {
            const d = new Date();
            d.setTime(d.getTime() + expires);
            cookie += 'expires=' + d['toUTCString']() + ';';
        }
        window.document.cookie = cookie;
    },
    get: (name) => {
        name = name + '=';
        const ca = window.document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return decodeURIComponent(c.substring(name.length, c.length));
            }
        }
        return '';
    },
    unset: (name) => {
        window.document.cookie = name + '=; path=/; Max-Age=-99999999;';
    },
};
